// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/components/customPage/showRecord/ShowRecord.scss
// module id = 4145
// module chunks = 50